import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import moment from "moment-jalaali";
import {
  BButton,
  BCard,
  BCollapse,
  BFormGroup,
  BFormInput,
  BTable,
  BTooltip,
  VBToggle,
} from "bootstrap-vue";
import { forEach } from "lodash";
export default {
  name: "HavaleCreate",
  components: {
    FormModal,
    Loading,
    BTooltip,
    BButton,
    BCollapse,
    BCard,
    BFormGroup,
    BFormInput,
    BTable,
    ProductSearch,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      productSelect: null,
      productSku: "",
      balanceProductSku: "",
      stores: [],
      sellers: [],
      stockmans: [],
      seller: null,
      stockman: null,
      varietySelect: null,
      destinationAgency: null,
      toStore: null,
      fromStore: null,
      isButtonDisabled: false,
      varieties: [],
    };
  },
  // computed: {
  // agencies() {
  // return this.$store.getters["admin/stores"];
  // },
  // },
  mounted() {
    this.loadStores();
    this.loadSellers();
    this.requestStockmans();
  },
  watch: {},
  methods: {
    async requestStockmans() {
      try {
        const response = await this.$axios.get("admin/stockmans");
        this.stockmans = response.data.data.admins;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            barcode: this.productSku,
            refund: 0,
          },
        });
        const variety = response.data.data.variety;
        this.balanceProductSku = response.data.data.balances;

        const exists = this.varieties.some((item) => item.id === variety.id);
        if (exists) {
          this.$root.notify("این تنوع تکراری است.", "warning");
          return;
        }
        this.varieties.push({
          ...variety,
          created_at: moment().format("jYYYY/jM/jD ساعت HH:mm:ss"),
          product_title: variety.product.title,
          from_store_name: this.fromStore.name,
          to_store_name: this.toStore.name,
        });
        this.productSku = null;
        $("#add-variety-modal").modal("hide");
        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    async loadStores() {
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async loadSellers() {
      try {
        const response = await this.$axios.get("admin/sellers?all=1&active=1");
        this.sellers = response.data.data.sellers;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    barcodeVarieties() {
      const shortenedVarieties = this.varieties.map((variety) => ({
        id: variety.id,
        product_title: variety.product_title,
        variety_title: variety.title ?? variety.variety_name,
        price: variety.price,
        attributes: variety.attributes,
        quantity: variety.agencyQuantity,
      }));
      const route = this.$router.resolve({
        path: "/admin/havale-barcodes",
        query: {
          varieties: JSON.stringify(shortenedVarieties),
        },
      });
      window.open(route.href, "_blank");
    },
    printVarieties() {
      const shortenedVarieties = this.varieties.map((variety) => ({
        id: variety.id,
        from_store_name: variety.from_store_name,
        to_store_name: variety.to_store_name,
        created_at: variety.created_at,
        product_title: variety.product_title,
        variety_title: variety.variety_title,
        title: variety.title,
        quantity: variety.store_items.find(
          (item) => item.store_id == this.fromStore.id,
        ).balance,
        agencyQuantity: variety.agencyQuantity,
      }));
      const route = this.$router.resolve({
        path: "/admin/havale-print",
        query: {
          varieties: JSON.stringify(shortenedVarieties),
        },
      });
      window.open(window.location.origin + route.href, "_blank");
    },
    selectedVariety(item) {
      this.varietySelect = item;
    },
    selectTheProduct(item) {
      this.productSelect = item;
    },
    addVariety() {
      if (this.varietySelect) {
        const exists = this.varieties.some(
          (variety) => variety.id === this.varietySelect.id,
        );
        if (exists) {
          this.$root.notify("این تنوع تکراری است.", "warning");
          return;
        }
        this.varieties.push({
          ...this.varietySelect,
          created_at: moment().format("jYYYY/jM/jD ساعت HH:mm:ss"),
          product_title: this.productSelect.title,
          from_store_name: this.fromStore.name,
          to_store_name: this.toStore.name,
        });
        this.varietySelect = null;
        $("#add-variety-modal").modal("hide");
      } else {
        if (this.productSelect) {
          const newVarieties = this.productSelect.varieties.map((item) => ({
            ...item,
            created_at: moment().format("jYYYY/jM/jD ساعت HH:mm:ss"),
            product_title: this.productSelect.title,
            from_store_name: this.fromStore.name,
            to_store_name: this.toStore.name,
          }));
          newVarieties.forEach((variety) => {
            const balanceItem = variety.store_items.find(
              (item) => item.store_id == this.fromStore.id,
            );
            variety.store_balance = balanceItem ? balanceItem.balance : 0;
          });
          const filteredVarieties = newVarieties.filter(
            (variety) => variety.store_balance != 0,
          );
          this.varieties.push(...filteredVarieties);
          this.varietySelect = null;
          $("#add-variety-modal").modal("hide");
        }
      }
    },
    deleteVariety(index) {
      this.varieties.splice(index, 1);
    },
    async submitData() {
      const selectedFromStore = this.fromStore;
      const selectedToStore = this.toStore;
      const data = {
        from_store_id: selectedFromStore.id,
        to_store_id: selectedToStore.id,
        // transmitter_id: this.seller ? this.seller.id : '',
        transmitter_id: this.stockman ? this.stockman.id : "",
        varieties: this.varieties.map((variety) => ({
          id: variety.id,
          quantity: variety.agencyQuantity,
        })),
      };
      try {
        const response = await this.$axios.post(
          "admin/stores/remittance",
          data,
        );
        this.$root.notify(response.data.message, "success");
        this.isButtonDisabled = true;
      } catch (error) {
        this.$root.notify(error);
      }
    },
  },
};
